module.exports = __webpack_public_path__ + "static/img/12.83992ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/12.png
// module id = HjnB
// module chunks = 0